<div id="configurable-settings-setup" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container">
  <div cdkDragHandle class="flex justify-between items-baseline pr-4">
    <h2 mat-dialog-title>Configurable Settings</h2>
    <button type="button" mat-icon-button class="leading-none" mat-dialog-close><mat-icon>close</mat-icon></button>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content>
    @if (message.type) {
      <app-sms-notice-banner #messageBanner [type]="message.type" (closeBanner)="clearMessage(0)">
        <p>{{ message.text }}</p>
      </app-sms-notice-banner>
    }
    <mat-tab-group #tabGroup (selectedTabChange)="tabClick($event)">
      <mat-tab label="Client Self-Service">

        @if (isLoading) {
          <app-sms-spinner></app-sms-spinner>
        } @else {
          @if (ldlDisableBulkEmail) {
            <p class="text-red my-2 text-base">
              We are experiencing technical difficulties with our bulk email vendor. The bulk Client Self-Service Data (SSP) Invite email send function is disabled at this time, meaning no bulk SSPs will be sent out. Once issues have been resolved, we will restore our connection and proceed with bulk SSP emails as appropriate.
            </p>
          }
          <form name="configurableSettingForm" id="configurableSettingForm" [formGroup]="configurableSettingForm">
            @if(false) { <!-- R2026Q3.3.1 -->
            <span class="flex items-baseline">
              <p class="py-2">Include Scope of Appointment in Self-Service Invites?</p>
              <button mat-icon-button type="button" color="basic" matTooltip='If Include Scope of Appointment (SOA) is turned ON then your Client Self-Service email invitations will also include the remote SOA form.  Your clients will be automatically redirected to the online SOA form after completing their Self-Service demographic information updates.  You will receive separate notifications from the system, depending on your communication preferences, every time a client accesses and/or completes the self-service updates and/or the SOA.' matTooltipPosition="right" [matTooltipShowDelay]="800">
                <mat-icon class="text-emerald-800 align-bottom">help</mat-icon>
              </button>
            </span>
            <p class="pb-2 leading-5 font-semibold italic text-red">NOTE: A change to this Scope of Appointment setting only applies to new Client Self-Service links sent out. Any existing links will not follow the new SOA setting.</p>
            <mat-radio-group aria-label="Include Scope of Appointment in Self-Service Invites?" (change)="sspSettingChange()" formControlName="sspsoa_configurable_settings">
              <mat-radio-button value="1" class="mr-8 block">Yes</mat-radio-button>
              <mat-radio-button value="0" class="mr-8 block">No</mat-radio-button>
            </mat-radio-group>
            <br>
            }
            <span class="flex items-baseline">
              <p class="py-2">Send automated reminder emails for Client Self-Service invites?</p>
              <button mat-icon-button type="button" color="basic" matTooltip='If reminder emails are turned ON, your client will receive an automatic reminder email seven days after receiving their Client Self-Service invitation, if they do not submit a response before then. They will receive a second and final reminder email three days after the first reminder, if they do not submit a response after the first reminder. Reminder emails will be identical to the initial invitation, with the word "REMINDER" in the subject line.' matTooltipPosition="right" [matTooltipShowDelay]="800">
                <mat-icon class="text-emerald-800 align-bottom">help</mat-icon>
              </button>
            </span>
            <p class="pb-2 leading-5 font-semibold italic text-red">NOTE: A change to the automated reminder setting only applies to new Client Self-Service links sent out. Any active links that qualify for a reminder will still receive reminder emails. Client Self-Service links are active for 60 days.</p>
            <mat-radio-group aria-label="Send automated reminder emails for Client Self-Service invites?" (change)="sspSettingChange()" formControlName="sspr_configurable_settings">
              <mat-radio-button value="1" class="mr-8 block">Yes</mat-radio-button>
              <mat-radio-button value="0" class="mr-8 block">No</mat-radio-button>
            </mat-radio-group>
            <br>
              <!--https://leadadvantage.atlassian.net/browse/SSPUP-47 -->
              <span class="flex items-baseline">
                <p class="py-2">Allow clients to update Personal Information in Section 1 of Client Self-Service?</p>
                <button mat-icon-button type="button" color="basic" matTooltip='If Personal Information updates are turned ON, your client will be able to update most of their Personal Information in Section 1 of Client Self-Service. You will be able to see the client changes in a ledger on Lead Details. If your client needs to edit their first name, last name, initial, or date of birth, they will need to contact you regarding that change.' matTooltipPosition="right" [matTooltipShowDelay]="800">
                  <mat-icon class="text-emerald-800 align-bottom">help</mat-icon>
                </button>
              </span>
              <p class="pb-2 leading-5 font-semibold italic text-red">NOTE: A change to this Personal Information setting only applies to new Client Self-Service links sent out. Any existing
              links will not follow the new permission setting.</p>
              <mat-radio-group aria-label="Allow clients to update Personal Information in Section 1 of Client Self-Service?" (change)="sspSettingChange()" formControlName="sspup_configurable_settings">
                <mat-radio-button value="1" class="mr-8 block">Yes</mat-radio-button>
                <mat-radio-button value="0" class="mr-8 block">No</mat-radio-button>
              </mat-radio-group>
            </form>
          }

        </mat-tab>
        <mat-tab label="Communication Preferences">

          @if (isLoading) {
            <app-sms-spinner></app-sms-spinner>
          } @else {
            <div class="flex gap-3">
              <div class="w-1/2">
                <table mat-table [dataSource]="dataSource" class="table-auto">
                  <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef class="w-70 align-right"> </th>
                    <td mat-cell *matCellDef="let element" class="w-70"> {{ element.value.communication_notification_type_description }} </td>
                  </ng-container>
                  <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef class="w-15"> Email </th>
                    <td mat-cell *matCellDef="let element" class="w-15">
                      <div [formGroup]="element">
                        @if (element.value.communication_notification_type_id !== notificationTypes.LA_PRO_UPDATES) {
                          <mat-checkbox formControlName="communication_preference_bit_email" (change)="onCheckboxChange(element.value.communication_notification_type_id, 'communication_preference_bit_email', element.value.communication_preference_bit_email)" [disabled]="batchDisabled">
                          </mat-checkbox>
                        }
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="text">
                    <th mat-header-cell *matHeaderCellDef class="w-15"> Text </th>
                    <td mat-cell *matCellDef="let element" class="w-15">
                      <div [formGroup]="element">
                        <mat-checkbox formControlName="communication_preference_bit_text" (change)="onCheckboxChange(element.value.communication_notification_type_id, 'communication_preference_bit_text', element.value.communication_preference_bit_text)" [disabled]="disableTexting">
                        </mat-checkbox>
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="inApp">
                    <th mat-header-cell *matHeaderCellDef class="w-15"> In-App </th>
                    <td mat-cell *matCellDef="let element" class="w-15">
                      <div [formGroup]="element">
                        @if (element.value.communication_notification_type_id !== notificationTypes.LA_PRO_UPDATES) {
                          <mat-checkbox formControlName="communication_preference_bit_inapp" (change)="onCheckboxChange(element.value.communication_notification_type_id, 'communication_preference_bit_inapp', element.value.communication_preference_bit_inapp)">
                          </mat-checkbox>
                        }
                        @if (element.value.communication_notification_type_id == notificationTypes.LA_PRO_UPDATES) {
                          <mat-checkbox disabled="true" checked="true">
                          </mat-checkbox>
                        }
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="emptyHeader">
                    <th mat-header-cell *matHeaderCellDef class="w-70"> </th>
                  </ng-container>
                  <ng-container matColumnDef="notifications">
                    <th mat-header-cell *matHeaderCellDef [attr.colspan]="3" style="text-align: center; vertical-align: bottom;"> Notifications </th>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="['emptyHeader', 'notifications']"></tr>
                  <tr mat-header-row *matHeaderRowDef="['description', 'email', 'text', 'inApp']"></tr>
                  <tr mat-row *matRowDef="let row; columns: ['description', 'email', 'text', 'inApp'];"></tr>
                </table>
              </div>
              <div class="w-1/2">
                <form name="phoneNumberForm" id="phoneNumberForm" [formGroup]="phoneNumberForm">
                  <div class="flex gap-3 place-items-center">
                    <mat-form-field class="w-[25%]">
                      <mat-label>Type</mat-label>
                      <input matInput formControlName="phone_type" readonly>
                    </mat-form-field>
                    <mat-form-field class="w-[75%]">
                      <mat-label>Phone</mat-label>
                      <input matInput formControlName="phone" appPhoneNumberMask readonly>
                    </mat-form-field>
                  </div>
                </form>
                <p>
                  @if (textAppend) {
                    <span [innerHTML]="processmessage"></span>
                    } @if (textAppend) {
                    <span class="font-bold italic cursor-pointer linked-td" (click)="openUserProfile()">User Profile</span>
                  }
                  @if (!textAppend) {
                    <span class="red" [innerHTML]="processmessage"></span>
                  }
                </p>
                @if (batchNotice) {
                  <table class="table-auto mt-3">
                    <tr>
                      <td class="w-15">
                        <form [formGroup]="batchNoticeForm">
                          <mat-checkbox formControlName="communication_preference_bit_email" (change)="onBatchCheckboxChange(batchNoticeForm.value.communication_notification_type_id, 'communication_preference_bit_email', batchNoticeForm.value.communication_preference_bit_email)">
                          </mat-checkbox>
                        </form>
                      </td>
                      <td class="w-70"> {{ batchNotice.communication_notification_type_description }} </td>
                    </tr>
                  </table>
                }
              </div>
            </div>
          }

        </mat-tab>
        <mat-tab label="Enhanced SOA">
          @if (isLoading) {
            <app-sms-spinner></app-sms-spinner>
          } @else {
            @if (ldlDisableBulkEmail) {
              <p class="text-red my-2 text-base">
                We are experiencing technical difficulties with our bulk email vendor. The bulk Scope of Appointment (SOA) email send function is disabled at this time, meaning no bulk SOAs will be sent out. Once issues have been resolved, we will restore our connection and proceed with bulk SOA emails as appropriate.
              </p>
            }
            <form name="enhancedSOAForm" id="enhancedSOAForm" [formGroup]="enhancedSOAForm" class="text-gray-800">
              <p class="py-2">A compliant Scope of Appointment (SOA) must be signed by both the agent and the client, and must include the date of the appointment. 
                
              </p>
              <p class="py-2">The Enhanced SOA process enables the client to complete and sign the SOA form without scheduling an appointment with the agent. Or if the agent prefers, the client can schedule an appointment using the agent's preferred online appointment scheduling tool. The Enhanced SOA can be sent to one or more leads, up to 5,000 emails per send.</p>
              <p class="py-2">For Enhanced SOAs, agents are responsible for entering the appointment date after the client signs the SOA form. For all SOAs, this date can be entered or changed at any time to accommodate scheduling realities.</p>
              <p class="py-2"><strong>You must check the box below to utilize Enhanced SOA.</strong></p>
              <div class="items-start">
                <mat-checkbox [checked]="enhancedSOAForm.value.enhanced_soa_acknowledged" formControlName="enhanced_soa_acknowledged" (click)="toggleSOASelfServiceInvite();">
                </mat-checkbox>
                <span class="ml-1">
                  <strong>By checking this box, I acknowledge:</strong>
                  <ul class="pl-8 ml-2 list-decimal">
                    <li class="ml-4">
                      When using the appointment setting option (copy and paste URL in box below), I am responsible for configuring my preferred online appointment scheduling tool.
                    </li>
                    <li class="ml-4">
                      The platform does not require the beneficiary to enter the appointment date in the SOA; it is my responsibility to enter a valid appointment date to finalize a compliant SOA form.
                    </li>
                  </ul>
                </span>
                <mat-form-field class="w-full mt-2">
                  <input matInput formControlName="enhanced_soa_url" placeholder="(Copy and paste scheduler URL link here)" />
                </mat-form-field>
                <span class="text-red">Entering this URL is optional (but encouraged) for use of the Enhanced SOA process. It is strongly suggested you test the URL via the “Test URL” button before you save your changes. It is required that https:// is included in the URL you paste into the section above.</span>
              </div>
            </form>
          }

        </mat-tab>
      </mat-tab-group>
    </div>

    @if (configurableSettingForm.dirty || communicationPreferencesSettingsUpdate || enhancedSOASettings) {
      <div mat-dialog-actions align="end">
        <div class="w-full flex flex-row justify-between items-center">
          <div class="flex gap-2">
            @if (enhancedSOASettings) {
              <button mat-flat-button class="lap-warn" (click)="loadUrl()" [disabled]="!enhancedSOAForm.valid || enhancedSOAForm.value.enhanced_soa_url.length === 0">Test URL</button>
            }
          </div>
          <div mat-dialog-actions class="flex gap-2 mt-4">
            @if ((sspConfigurableSettings && configurableSettingForm.dirty) || (communicationPreferencesSettings && communicationPreferencesSettingsUpdate) || (enhancedSOASettings && enhancedSOAForm.dirty)) {
              <button mat-button mat-raised-button mat-dialog-close>Cancel</button>
            }
            @if (sspConfigurableSettings && configurableSettingForm.dirty) {
              <button mat-button mat-flat-button mat-dialog-close (click)="selfServiceConfigUpdate(configurableSettingForm.value.sspr_configurable_settings, configurableSettingForm.value.sspup_configurable_settings, configurableSettingForm.value.sspsoa_configurable_settings)">Update</button>
            }
            @if (communicationPreferencesSettings && communicationPreferencesSettingsUpdate) {
              <button mat-button mat-flat-button mat-dialog-close (click)="communicationPreferencesUpdate()">Update</button>
            }
            @if (enhancedSOASettings && enhancedSOAForm.dirty 
              && (!enhancedSOAForm.value.enhanced_soa_url 
                || !enhancedSOAForm.get('enhanced_soa_url')?.dirty 
                || enhancedSOAForm.value.enhanced_soa_acknowledged)) {
              <button mat-button mat-flat-button mat-dialog-close [disabled]="!enhancedSOAForm.valid" (click)="updateEnhancedSOA()">Update</button>
            }
          </div>
        </div>
      </div>
    }
  </div>
